import { formatDate } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

declare var $: any;
@Component({
  selector: 'app-date-range',
  standalone:true,
  imports:[TranslateModule],
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss'],
})
export class DateRangeComponent implements OnChanges, AfterViewInit {
  data: Date = new Date();

  @Input() hasTime: boolean = true;
  @Input() minValue: Date = this.data;
  @Input() maxValue: Date = this.data;
  @Input() monthDateLimit: any = 12;
  @Input() defaultValue: { from: Date; to: Date } = {
    from: this.data,
    to: this.data,
  };
  @Input() placeholder?:string;
  @Input() classDate?: string;
  @Input() openInModal: boolean = false;
  @Input() isTimeOnly: boolean = false;
  @Input() timePickerIncrement: any = 30;
  @Input() autoApply: boolean = false;
  @Output() onDateChange: EventEmitter<{ from?: any; to?: any }> =
    new EventEmitter<{ from?: Date; to?: Date }>();
  @Input() hideButtonClasses: boolean = false;
  id: string = `${new Date().getTime()}`;

  ngOnChanges(changes: SimpleChanges): void {
    this.ngAfterViewInit();
  }

  ngAfterViewInit(): void {
    if (this.openInModal) {
      $('body').delegate('#' + this.id, 'focusin', () => {
        this.initDatePicker();
      });
    } else {
      this.initDatePicker();
    }

    // $('#datetime').datetimepicker({
    //   showSecond: true,
    //   timeFormat: 'hh:mm:ss',
    //   stepHour: 2,
    //   stepMinute: 10,
    //   stepSecond: 10
    //   });
  }

  initDatePicker() {
    let data = new Date();
    data.setDate(1);
    const rangeValue = {
      from: data,
      to: new Date()
    };
    if (this.isTimeOnly) {
      $('#' + this.id)
        .daterangepicker(
          {
            timePicker: true,
            timePicker24Hour: true,
            timePickerIncrement: this.timePickerIncrement,
            timePickerSeconds: false,
            startDate: this.defaultValue ? this.defaultValue.from : rangeValue.from,
            endDate: this.defaultValue ? this.defaultValue.to : rangeValue.to,
            locale: {
              format: 'HH:mm',
            },
          },
          (start: any, end: any, label: any) => {
            this.onDateChange.emit({
              from: formatDate(start._d, 'HH:mm', 'en'),
              to: formatDate(end._d, 'HH:mm', 'en'),
            });
          }
        )
        .on('show.daterangepicker', function (ev: any, picker: any) {
          picker.container.find('.calendar-table').hide();
        });
    } else {
      $('#' + this.id).daterangepicker(
        {
          locale: {
            format: this.hasTime ? 'YYYY/MM/DD HH:mm' : 'YYYY/MM/DD',
          },
          startDate: this.defaultValue ? this.defaultValue.from : rangeValue.from,
          endDate: this.defaultValue ? this.defaultValue.to : rangeValue.to,
          minDate: this.minValue,
          maxDate: this.maxValue,
          timePicker: this.hasTime,
          timePicker24Hour: this.hasTime,
          dateLimit: {
            months: this.monthDateLimit,
          },
          buttonClasses: this.hideButtonClasses ? 'd-none' : 'btn btn-sm',
          showDropdowns: true,
          autoApply: this.autoApply,
        },
        (start: any, end: any, label: any) => {
          // Logger.debug('start', new Date(start._d));
          // Logger.debug('end', new Date(end._d));
          this.onDateChange.emit({
            from: new Date(start._d),
            to: new Date(end._d),
          });
        }
      );


    }
    // set empty value to show placeholder
    if(!this.defaultValue) {
      $('#' + this.id).val('');
    }
  }
}
